import { PARAMS } from 'constants/pages';
import { isArrayEmpty } from '../../../utility/helpers';
import { getPersonFullName } from '../../../utility/uiUtils';
import { primaryPalette } from '../../../styles/theme';
import { COMPETENCE_MAP_ATTRIBUTE_CONFIG } from '../../../constants/attributes';

export const NOTIFICATION_DELAY = 300;

export const NOTIFICATION_CLEAR_DELAY = 2000;

export const MAX_SELECTED_SCORES = 3;

export const MIN_ATTRIBUTE_MATCHES = 1;

export const NO_SCORE_PLACEHOLDER = '-';

export const TOTAL_NUMBER_OF_SCORES = 11; // 0-10 array(11 items)

export const prepareInitiallySelectedAttributes = measuredAttributes => {
  if (!isArrayEmpty(measuredAttributes)) {
    return measuredAttributes.slice(0, COMPETENCE_MAP_ATTRIBUTE_CONFIG.DEFAULT);
  }

  return measuredAttributes;
};

export const prepareChartData = attributeScores => ({
  datasets: [
    ...attributeScores,
    ...(attributeScores.length < COMPETENCE_MAP_ATTRIBUTE_CONFIG.MAX
      ? Array.from(
          {
            length:
              COMPETENCE_MAP_ATTRIBUTE_CONFIG.MAX - attributeScores.length,
          },
          (_, i) => ({
            name: `placeholder_bar_${i}`,
            stats: new Array(TOTAL_NUMBER_OF_SCORES).fill(0),
          })
        )
      : []),
  ].reduce(
    (acc, attr) => [
      ...acc,
      {
        label: attr.name,
        data: Object.values(attr.stats),
        backgroundColor: attr.color,
        borderColor: primaryPalette.white,
        borderWidth: 1,
        barPercentage: 1,
        categoryPercentage: 0.98,
      },
    ],
    []
  ),
});

export const updateSelectedScores = (selectedScores, scoreDistribution) =>
  selectedScores.filter(selectedScore =>
    scoreDistribution.some(score => Object.values(score.stats)[selectedScore])
  );

export const handlePeriod = (initialPreset, period) => {
  return {
    [PARAMS.START]: initialPreset
      ? initialPreset?.data?.period?.start
      : period.start,
    [PARAMS.END]: initialPreset ? initialPreset?.data?.period?.end : period.end,
  };
};

export const prepareMatchedUsers = (usersScores, selectedAttributes) => {
  if (isArrayEmpty(usersScores) || isArrayEmpty(selectedAttributes)) {
    return [];
  }

  const userIndex = new Map();

  usersScores.forEach(attributeGroup => {
    (attributeGroup.users || []).forEach(user => {
      if (!userIndex.has(user.id)) {
        userIndex.set(user.id, {
          user,
          scoresByAttributeId: new Map(),
        });
      }

      userIndex
        .get(user.id)
        .scoresByAttributeId.set(attributeGroup.id, user.score);
    });
  });

  return Array.from(userIndex.values())
    .map(({ user, scoresByAttributeId }) => {
      const attributesWithScores = selectedAttributes.map(attribute => ({
        ...attribute,
        score: scoresByAttributeId.has(attribute.id)
          ? scoresByAttributeId.get(attribute.id)
          : null,
      }));
      const matchCount = attributesWithScores.filter(
        attribute => attribute.score !== null && attribute.score !== undefined
      ).length;

      return {
        user,
        attributesWithScores,
        matchCount,
        totalAttributes: selectedAttributes.length,
      };
    })
    .filter(({ matchCount }) => matchCount >= MIN_ATTRIBUTE_MATCHES)
    .sort((a, b) => {
      if (b.matchCount !== a.matchCount) {
        return b.matchCount - a.matchCount;
      }

      return getPersonFullName(a.user).localeCompare(getPersonFullName(b.user));
    });
};
